// function for setting cell color based on percentage //
import React from "react"
import tinycolor from 'tinycolor2'

const EpaComp = ({val, percision }) => {

    // func for imperceisely handling float-point rounding hell //
    function truncate (num, places) {
        if (Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places) === 0) {
            return 0.00
        } else {
            return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places)
        }
    }

    var parsedVal = parseFloat(val)

    // colors //
    const pos_color = '#e8fcf6'
    const mid_color = '#ffffff'
    const neg_color = '#ffe6ef'

    // default style //
    var displayStyle = {
        background : 'white',
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }


    // set color styles //
    if (isNaN(parsedVal)) {

        // grey //
        displayStyle['color'] = '#ababab'

    } else if (parsedVal >= 0) {
        
        // positive color //
        displayStyle['background'] = tinycolor.mix(mid_color, pos_color, 100 * parsedVal / .07)
        displayStyle['color'] = '#259c72'
 
    } else if (parsedVal < 0) {
       
       // negative color //
       displayStyle['background'] = tinycolor.mix(mid_color, neg_color, -100 * parsedVal / .07)
       displayStyle['color'] = '#bf2a5e'

    }

    return (
        <div
            style={displayStyle}
        >
            {
                isNaN(parsedVal) ? '--' : truncate(parsedVal, percision)}
        </div>
    )
    
}

export default EpaComp